var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-select',_vm._b({class:{ 'is-focused': _vm.isFocused },on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"input":_vm.onInput}},'b-select',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }